import React, { useCallback, FC } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { Container, Labels, DropLabel, SupportLabel, Files, File } from './Dropzone.styles';
import CloseIcon from '@/assets/icons/closeMark.svg?react';
import DropdownIcon from '@/assets/icons/download.svg?react';
import SuccessIcon from '@/assets/icons/successFile.svg?react';

interface IDropzone {
  supportMessage?: string;
}

const Dropzone: FC<IDropzone> = ({ supportMessage }) => {
  const [file, setFile] = React.useState<any>(null);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    maxFiles: 1,
    onDrop: useCallback((acceptedFiles: any) => {
      setFile(acceptedFiles[0]);
    }, []),
    accept: {
      'text/csv': ['.csv'],
      'text/plain': ['.csv'],
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    },
  });

  const { t } = useTranslation();

  if (file) {
    return (
      <Files>
        <File>
          <SuccessIcon />
          {file.name}
          <CloseIcon onClick={() => setFile(null)} />
        </File>
      </Files>
    );
  }

  return (
    <Container {...getRootProps()}>
      <input {...getInputProps()} />

      <Labels>
        <DropdownIcon />
        {isDragActive ? (
          <DropLabel>{t('dropzone.dropActive')}</DropLabel>
        ) : (
          <DropLabel>
            {t('dropzone.dropInactive')} <span>{t('dropzone.browse')}</span>
          </DropLabel>
        )}
        <SupportLabel>{supportMessage || t('dropzone.support')}</SupportLabel>
      </Labels>
    </Container>
  );
};

export default Dropzone;
